<app-modal [header]="headerRef" (destroy)="dismiss()">
  <div class="file-block" modal-content>
    <div class="modal-content">
      <p class="f-text">{{msg}}</p>
      @if (
        loadingService.States[
        loadingService.getIdFromArrayStateByType(
        loadingService.StatesNames.DELETE_NEWS
        )
        ].value ||
        loadingService.States[
        loadingService.getIdFromArrayStateByType(
        loadingService.StatesNames.DELETE_NEWS
        )
        ].value) {
        <div
          >
          <app-preloader></app-preloader>
        </div>
      } @else {
        <div class="buttons-modal">
          <button  class="btn-custom btn-active" (click)="close(true)">
            Да
          </button>
          <button class="btn-custom btn-delete"   (click)="dismiss(false)">
            Нет
          </button>
        </div>
      }
    </div>
  </div>


</app-modal>
<ng-template #headerRef>
  <h6 class="modal--header f-title">{{title}}</h6>
</ng-template>
